import React, { useState } from 'react';
import styled from 'styled-components';

const IAOfficersAdd = ({ onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    surname: '',
    firstname: '',
    mothers_maiden_name: '',
    sex: '',
    civil_status: '',
    name_of_spouse: '',
    date_of_birth: '',
    tin: '',
    position: '',
    educational_attainment: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (typeof onSubmit === 'function') {
      onSubmit(formData);
    } else {
      console.log('IA Officer added:', formData);
    }
    onClose();
  };

  return (
    <FormPanel>
      <FormHeader>
        <Title>Add IA Officer</Title>
        <Icons>
          <CloseBtn onClick={onClose}>✖</CloseBtn>
        </Icons>
      </FormHeader>
      <FormBody>
        <Row>
          <Field>
            <Label>Surname</Label>
            <Input name="surname" value={formData.surname} onChange={handleChange} />
          </Field>
          <Field>
            <Label>First Name</Label>
            <Input name="firstname" value={formData.firstname} onChange={handleChange} />
          </Field>
        </Row>

        <Row>
          <Field>
            <Label>Mother's Maiden Name</Label>
            <Input name="mothers_maiden_name" value={formData.mothers_maiden_name} onChange={handleChange} />
          </Field>
          <Field>
            <Label>Sex</Label>
            <Select name="sex" value={formData.sex} onChange={handleChange}>
              <option value="">Select</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </Select>
          </Field>
        </Row>

        <Row>
          <Field>
            <Label>Civil Status</Label>
            <Select name="civil_status" value={formData.civil_status} onChange={handleChange}>
              <option value="">Select</option>
              <option value="Single">Single</option>
              <option value="Married">Married</option>
              <option value="Widowed">Widowed</option>
              <option value="Separated">Separated</option>
            </Select>
          </Field>
          <Field>
            <Label>Name of Spouse</Label>
            <Input name="name_of_spouse" value={formData.name_of_spouse} onChange={handleChange} />
          </Field>
        </Row>

        <Row>
          <Field>
            <Label>Date of Birth</Label>
            <Input type="date" name="date_of_birth" value={formData.date_of_birth} onChange={handleChange} />
          </Field>
          <Field>
            <Label>TIN</Label>
            <Input name="tin" value={formData.tin} onChange={handleChange} />
          </Field>
        </Row>

        <Row>
          <Field>
            <Label>Position</Label>
            <Input name="position" value={formData.position} onChange={handleChange} />
          </Field>
          <Field>
            <Label>Educational Attainment</Label>
            <Input name="educational_attainment" value={formData.educational_attainment} onChange={handleChange} />
          </Field>
        </Row>
      </FormBody>

      <FormFooter>
        <AddButton onClick={handleSubmit}>Add Officer</AddButton>
      </FormFooter>
    </FormPanel>
  );
};

export default IAOfficersAdd;

const FormPanel = styled.div`
  width: 700px;
  max-height: 90vh;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  font-family: 'Segoe UI', sans-serif;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const FormHeader = styled.div`
  background-color: #2e7d32;
  color: white;
  padding: 5px 20px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 16px;
`;

const Icons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const CloseBtn = styled.button`
  background: none;
  color: white;
  font-size: 20px;
  border: none;
  cursor: pointer;

  &:hover {
    color: #ffdede;
  }
`;

const FormBody = styled.div`
  padding: 10px 20px 20px;
  overflow-y: auto;
  flex-grow: 1;
`;

const FormFooter = styled.div`
  padding: 15px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  background-color: #f9f9f9;
`;

const AddButton = styled.button`
  padding: 10px 20px;
  background-color: #2e7d32;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background-color: #27672a;
  }
`;

const Row = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 15px;

  & > div {
    flex: 1;
  }
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-size: 13px;
  margin-bottom: 4px;
  color: #555;
`;

const Input = styled.input`
  padding: 10px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #ccc;

  &:focus {
    outline: none;
    border-color: #4caf50;
    box-shadow: 0 0 4px rgba(76, 175, 80, 0.3);
  }
`;

const Select = styled.select`
  padding: 10px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #ccc;

  &:focus {
    outline: none;
    border-color: #4caf50;
    box-shadow: 0 0 4px rgba(76, 175, 80, 0.3);
  }
`;
